var _excluded = ["animated", "className", "isOpen", "zIndex", "shouldLockBodyScoll"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'classnames';
import React, { useEffect } from 'react';
import { lockBody } from '../../utils/window';
import styles from './styles.module.scss';
export var AllBackdropZIndexOptions = ['fab', 'tooltip', 'dropdown', 'backdrop', 'banner', 'nav', 'sheet', 'modal', 'spinner', 'alert'];

var Backdrop = function Backdrop(_ref) {
  var _classNames;

  var _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? true : _ref$animated,
      className = _ref.className,
      isOpen = _ref.isOpen,
      zIndex = _ref.zIndex,
      _ref$shouldLockBodySc = _ref.shouldLockBodyScoll,
      shouldLockBodyScoll = _ref$shouldLockBodySc === void 0 ? true : _ref$shouldLockBodySc,
      htmlAttributes = _objectWithoutProperties(_ref, _excluded);

  var overridingStyle = Number(zIndex) > 0 ? {
    zIndex: Number(zIndex)
  } : {};
  var mergedClassName = classNames(styles.backdrop, className, (_classNames = {}, _defineProperty(_classNames, styles.animated, animated), _defineProperty(_classNames, styles.open, isOpen), _defineProperty(_classNames, styles["z-index-".concat(zIndex || 'backdrop')], zIndex !== undefined && typeof zIndex === 'string'), _classNames));
  useEffect(function () {
    lockBody('backdrop', isOpen && shouldLockBodyScoll);
  }, [isOpen, shouldLockBodyScoll]);
  if (!animated && !isOpen) return null;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: mergedClassName,
    style: overridingStyle,
    "data-testid": "backdrop"
  }, htmlAttributes));
};

export default Backdrop;